import { Check, Cloud } from "lucide-react";

/**
 * Pastille liste (style WhatsApp) :
 * - idle = nuage (pas encore sur DD02)
 * - warming = rien (traitement en cours)
 * - ready = 1 coche (serveur DD02 OK, pas encore hydraté sur ce poste)
 * - hydrated = 2 coches croisées (serveur OK + hydratation client)
 */
export type MessageBodyCacheStatus = "idle" | "warming" | "ready" | "hydrated";

type Props = {
  status: MessageBodyCacheStatus;
};

export function MessageBodyCacheBadge({ status }: Props) {
  if (status === "hydrated") {
    return (
      <span
        className="relative inline-flex h-3.5 w-[1.05rem] shrink-0 items-center"
        aria-label="Sur le serveur et hydraté sur cet appareil"
        title="Serveur + hydratation locale"
      >
        <Check
          className="absolute left-0 top-0 h-3.5 w-3.5 text-[var(--mail-accent)]"
          strokeWidth={2.75}
        />
        <Check
          className="absolute left-[0.28rem] top-0 h-3.5 w-3.5 text-[var(--mail-accent)]"
          strokeWidth={2.75}
        />
      </span>
    );
  }

  if (status === "ready") {
    return (
      <span
        className="inline-flex shrink-0 items-center"
        aria-label="Sur le serveur — hydratation locale en attente"
        title="Serveur OK — pas encore hydraté ici"
      >
        <Check className="h-3.5 w-3.5 text-[var(--mail-accent)]" strokeWidth={2.75} />
      </span>
    );
  }

  if (status === "warming") {
    return null;
  }

  return (
    <span
      className="inline-flex shrink-0 items-center"
      aria-label="Pas encore sur le serveur"
      title="Pas encore sur le serveur"
    >
      <Cloud className="h-3.5 w-3.5 text-[var(--mail-muted)] opacity-80" strokeWidth={2} />
    </span>
  );
}

/** Ouverture autorisée dès qu’il y a au moins le serveur (1 coche) ou l’hydratation. */
export function isBodyCacheOpenable(status: MessageBodyCacheStatus): boolean {
  return status === "ready" || status === "hydrated";
}
